const styles = ({ BREAKPOINTS, COLORS }) => ({
  container: {
    fontSize: '20px',
    display: 'flex',
    borderBottom: '1px solid #ececec',
    whiteSpace: 'nowrap',
    '& > *': {
      margin: '0 0 -0.25em 2.2em',
      '&:first-child': {
        marginLeft: '0'
      }
    },
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      justifyContent: 'space-between'
    }
  },
  holder: {
    overflowX: 'auto'
  },
  hideMobile: {
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      display: 'none'
    }
  },
  current: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  currentCounter: {
    opacity: '0',
    animation: '0.3s fadeIn ease-out forwards',
    fontSize: '12px',
    lineHeight: '1.2',
    display: 'inline-flex',
    background: COLORS.RED.FADED,
    color: '#fff',
    margin: '2px 0 0 6px',
    fontWeight: 'bold',
    alignItems: 'center',
    justifyContent: 'center',
    width: '22px',
    height: '22px',
    borderRadius: '22px'
  },
  '@keyframes fadeIn': {
    from: { opacity: '0' },
    to: { opacity: '1' }
  },
  howIcon: {
    marginRight: '6px',
    color: COLORS.BLUE.NORMAL,
    top: '0px !important',
    fontSize: '16px'
  }
})

export default styles
